/**
 * Interface for the native push notification bridge.
 * This abstraction makes the code easier to test by allowing mock implementations.
 */
import { NativePushToken } from './types';

export const PUSH_TOKEN_REFRESH_EVENT = "pushNotification.tokenRefresh";

export function addNativePushTokenRefreshListener(handler: () => void): () => void {
    const listener = () => handler();
    window.addEventListener(PUSH_TOKEN_REFRESH_EVENT, listener);
    return () => window.removeEventListener(PUSH_TOKEN_REFRESH_EVENT, listener);
}

export interface INativePushNotificationBridge {
    getPushToken(
        params: undefined,
        callback: (error: Error | undefined, result: NativePushToken | undefined) => void
    ): void;
    
    startPushService(
        params: undefined,
        callback: (error: Error | undefined, result: any) => void
    ): void;
}

/**
 * Gets the native bridge from window.geotabModules.
 * Returns undefined if not available (e.g., in non-mobile environment).
 */
export function getNativeBridge(): INativePushNotificationBridge | undefined {
    return window.geotabModules?.pushNotification;
}
